import './CoursesPlansAlternate.scss';
import { useRouter } from 'next/router';
import icons from '../../../../shared/assets/icons/redesign';

const { ItemPlay, Check, EnglishFlag } = icons;

export default function CoursesPlans({
  user,
  showPopup,
  courseList,
  plans,
  addUserEvent
}) {
  const router = useRouter();
  const handleClick = (paymentItemType) => {
    addUserEvent({
      variables: { type: 'courses-buybutton', data: '{}' }
    });

    if (!user.username) return showPopup(true);

    router.push(
      `/zwangerschapscursus/betalen/verzekering?type=${paymentItemType}`
    );
  };

  return (
    <div className="coursesPlansAlternate">
      <div className="coursesPlansAlternate-header">
        <span />
        <span>Basis</span>
        <span className="text-center">
          Plus <br />
          (Meest gekozen)
        </span>
        <span>Pro</span>
      </div>
      <ul className="coursesPlansAlternate-course-list">
        {courseList.map((course) => (
          <li key={course.name} className="coursesPlansAlternate-course-list-item">
            <a
              href={`#${course.name}`}
              className="coursesPlansAlternate-course-list-item-link"
            >
              <span className="coursesPlansAlternate-course-list-item-play-icon-wrap">
                <ItemPlay className="coursesPlansAlternate-course-list-item-play-icon" />
              </span>
              <span>
                {course.displayName}{' '}
                {course.hasSubtitles && (
                  <EnglishFlag className="coursesPlansAlternate-course-list-item-subtitles-icon" />
                )}
              </span>
            </a>

            <span>
              {course.isBasis && (
                <Check className="coursesPlansAlternate-course-list-item-check-icon icon" />
              )}
            </span>
            <Check className="coursesPlansAlternate-course-list-item-check-icon icon" />
            <Check className="coursesPlansAlternate-course-list-item-check-icon icon" />
          </li>
        ))}
      </ul>

      <div className="coursesPlansAlternate-footer">
        <span className="coursesPlansAlternate-footer-subtitle area-1 _desktop">
          Aantal maanden toegang:
        </span>

        <CoursePlanItem
          className="coursesPlansAlternate-footer-plan-basis"
          name="Basis"
          duration="12"
          basicPrice={plans.basis.normaal}
          discountedPrice={plans.basis.nu}
          paymentType={plans.basis.type}
          onClick={handleClick}
        />

        <CoursePlanItem
          className="coursesPlansAlternate-footer-plan-plus"
          name={
            <>
              Plus <br />
              <span className="nowrap">(Meest gekozen)</span>
            </>
          }
          duration="18"
          basicPrice={plans.plus.normaal}
          discountedPrice={plans.plus.nu}
          paymentType={plans.plus.type}
          onClick={handleClick}
        />

        <CoursePlanItem
          className="coursesPlansAlternate-footer-plan-pro"
          name="Pro"
          duration="36"
          basicPrice={plans.pro.normaal}
          discountedPrice={plans.pro.nu}
          paymentType={plans.pro.type}
          onClick={handleClick}
        />
      </div>
    </div>
  );
}

function CoursePlanItem({
  className,
  name,
  duration,
  basicPrice,
  discountedPrice,
  paymentType,
  onClick
}) {
  return (
    <div className={className}>
      <span className="coursesPlansAlternate-footer-plan-name _mobile">{name}</span>
      <span className="coursesPlansAlternate-footer-plan-duration">
        {duration} maanden
      </span>

      <span className="coursesPlansAlternate-footer-plan-price-basic">
        Normaal €{basicPrice}
      </span>
      <span className="coursesPlansAlternate-footer-plan-price-discounted">
        Nu €{discountedPrice}
      </span>
      <button
        className="coursesPlansAlternate-button cursor-pointer"
        onClick={() => onClick(paymentType)}
      >
        Ja, ik wil nu toegang!
      </button>
    </div>
  );
}
